import { Modal, Button } from "react-bootstrap"

export const WarningModal = ({ message, onHide, onConfirm }) => {
    return (
        <Modal show onHide={ onHide } centered>
            <Modal.Header>
                <Modal.Title className="d-flex gap-2 align-items-center text-warning">Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="font-weight-semi-bold mt-1 mb-2">{ message }</p>
            </Modal.Body>
            <Modal.Footer>
                { onConfirm
                    ? <>
                        <Button size="sm" variant='default' onClick={ onHide }>Cancel</Button>
                        <Button size="sm" variant='success' onClick={ onConfirm }>Confirm</Button>
                    </>
                    : <Button size="sm" variant='primary' onClick={ onHide }>Ok</Button>
                }
            </Modal.Footer>
        </Modal>
    )
}
